/**
 * Created by DejanK on 10/10/2016.
 */

import angular from 'angular';
import {debounce} from 'lodash';

export default function(){
  return {
    controller: Ctrl
  }
}

Ctrl.$inject = ['$window', '$rootScope'];
function Ctrl($window, $rootScope){
  angular.element($window).on('resize', debounce(()=>{
    $rootScope.$broadcast('RbWindowResized');
  }, 20));
}
